import React, {
    Component
} from 'react';
import Async from 'react-async';
import './dbTable.css';
import {Formik, Form, Field} from 'formik';
import * as Yup from 'yup';
import EditForm from './editForm'
import { values } from 'underscore';
export default class DBTable extends Component {
    constructor(props){
        super(props);
        
        this.fetchTable=props.fetchTable;
        this.managerOn=props.managerOn;
        this.managerOff=props.managerOff;
        this.title=props.title;
        this.hasNew=props.hasNew || false;
        this.newFunction=props.newFunction ||{};
        this.deleteFunction=props.deleteFunction ||{};
        this.edit=props.edit || false;
        this.tableHeader=props.tableHeader || [];
        this.tableColumns=props.tableColumns || [];
        this.getUserInfo=props.getUserInfo || {};
        this.updateFunc=props.updateFunc || {};
        this.deleteSlot=props.deleteSlot || {};
        this.onChange = this.onChange.bind(this);
        this.renderNew= this.renderNew.bind(this);
        this.renderModal= this.renderModal.bind(this);
        this.renderDelete= this.renderDelete.bind(this);
        this.renderEdit= this.renderEdit.bind(this);
        this.renderNewButton= this.renderNewButton.bind(this);
        this.renderFormEdit=this.renderFormEdit.bind(this);
        this.state={modal:false, modalParams:{title:""}};
    }
    onChange(){
        let mTable=this.fetchTable();
        this.setState({table:mTable});
    }
    componentDidMount(){
        this.setState({table:[]})
        this.managerOn('change-table',this.onChange)
    }
    componentWillUnmount(){
        this.managerOff('change-table',this.onChange)
    }
    renderModal(){
        //let status=(show)?"open":""
        let type=this.state.modalParams.type || "";
        switch (type){
            case "new":
                return(
                    <dialog open={this.state.modal}>
                      {this.renderNew()} 
                    </dialog>
                )
            case "edit":
                return(
                    <dialog open={this.state.modal}>
                       {this.renderEdit()}
                    </dialog>
                )
            case "del":
                return(
                    <dialog open={this.state.modal}>
                       {this.renderDelete()}
                    </dialog>
                )
            default:
                return(
                    <dialog open={this.state.modal}>
                        <p className="pError">Modal desconocido</p>
                    </dialog> 
                )
        }

        
    }
    renderDelete(){
        return (
            <div className="dialog-container">
                <div className="dialog-content">
                    <div className="dialog-header">
                        <h1>{this.state.modalParams.title}</h1>
                        <div className="cross-close" onClick={()=>{
                            if (this.state.modal){
                                this.setState({modal:false});
                                
                            }
                        }}/>
                    </div>
                    <div className="dialog-body">
                        <p> Confirma que quieres borrar el elemento:</p>
                        <p> {JSON.stringify(this.state.modalParams.item)}</p>
                        <button onClick={()=>{
                            let item=this.state.modalParams.item;
                            this.deleteFunction(item);
                            if (this.state.modal){
                                this.setState({modal:false})
                            }
                        }}>
                            Confirmar
                        </button>
                    </div>
                </div>
            </div>
        )
    }
    renderFormEdit(data){
        let initialVal={};
        let numInstall=data.installations.length || 0;
        let totalInstal=data.installations_qty.number;
        initialVal.userData={};
        initialVal.userData.user=data.user.user;
        initialVal.userData.pass=data.pass.pass;
        initialVal.userData.install_qty=data.installations_qty.number;
        initialVal.userFeatures=[];
        initialVal.numInstall=numInstall;
        for (let i=0; i<data.features.length; i++){
            let feature=data.features[i];
            if (feature.value===1){
                initialVal.userFeatures.push(feature.feature)
            }
        }
        return (
            <EditForm 
                initialValues={initialVal}
                originalValues={data}
                updateFunc={this.updateFunc}
                deleteSlot={this.deleteSlot}
                numInstall={numInstall}
                />
        );

    }
    renderEdit(){
        let item=this.state.modalParams.item ||{};
        return (
            <div className="dialog-container">
                <div className="dialog-content">
                    <div className="dialog-header">
                       <h1>{this.state.modalParams.title}</h1>
                        <div className="cross-close" onClick={()=>{
                            if (this.state.modal){
                                this.setState({modal:false})
                            }
                        }}/>
                    </div>
                    <div className="dialog-body">
                        <Async promiseFn={this.getUserInfo} 
                               user={item.user || ""}
                               watch={item.user}>
                            <Async.Pending> 
                                Cargando ...
                            </Async.Pending>
                            <Async.Fulfilled>
                                {data => this.renderFormEdit(data)}
                            </Async.Fulfilled>
                            <Async.Rejected> 
                                {error => error.message}
                            </Async.Rejected>

                        </Async>
                    </div>
                </div>      
            </div>
        )
    }
    renderNew(){
        let initVal={};
        let columns=this.tableColumns;
        let labels=this.tableHeader;
        let validator;
        let table=[];
        for (let i=0; i<columns.length; i++){
            initVal[this.tableColumns[i]]="";
        }
        if (this.title==="Usuarios"){
            for(let i=0; i<this.state.table.length; i++){
                table.push(this.state.table[i].user)
            }
        } else {
            for(let i=0; i<this.state.table.length; i++){
                table.push(this.state.table[i].code)
            }
        }
        const valFeautures=Yup.object().shape({
            code: Yup.string()
                .min(2,"Mínimo 2 caracteres")
                .max(10,"Máximo 10 caracteres")
                .uppercase("Sólo mayúsculas")
                .required("Campo obligatorio")
                .notOneOf(table,"Característica repetida")
                .strict(true)

        });
        const valUser=Yup.object().shape({
            user: Yup.string()
                .min(2,"Mínimo 2 caracteres")
                .max(30,"Máximo 30 caracteres")
                .required("Campo obligatorio")
                .notOneOf(table,"Ya existe el usario"),
            pass: Yup.string()
                .min(2,"Mínimo 2 caracteres")
                .max(30,"Máximo 30 caracteres")
                .required("Campo obligatorio"),
            install_qty: Yup.number()
                .positive("Sólo números positivos")
                .integer("Sólo números enteros")
                .typeError("Sólo valores numéricos")
                .required("Campo obligatorio")
        })
        
        if (this.title==="Usuarios"){
            validator=valUser;
        } else {
            validator=valFeautures;
        }
        return(
            <div className="dialog-container">
                <div className="dialog-content">
                    <div className="dialog-header">
                       <h1>{this.state.modalParams.title}</h1>
                        <div className="cross-close" onClick={()=>{
                            if (this.state.modal){
                                this.setState({modal:false})
                            }
                        }}/>
                    </div>
                    <div className="dialog-body">
                        <Formik initialValues={initVal} 
                            onSubmit={(values)=>{this.newFunction(values)}}
                            validationSchema={validator}>
                            {(props)=>{
                                return(
                                    <form onSubmit={props.handleSubmit}>
                                        {columns.map((key,index)=>{
                                            return(
                                                <div className="formElement">
                                                    <label >
                                                        
                                                        {labels[index]}
                                                        
                                                    </label>
                                                    <input type="text"
                                                        id={key}
                                                        name={key}
                                                        value={props.values[key]}
                                                        placeholder={labels[index]}
                                                        onChange={props.handleChange}/>
                                                        {(props.errors[key]&&
                                                        props.touched[key])? 
                                                        (<p className="pError">
                                                            {props.errors[key]}
                                                        </p>):null}
                                                    </div>
                                            
                                            );
                                        })}
                                        <button type="submit" >
                                            Añadir
                                        </button>
                                    </form>
                                )
                            }}
                        </Formik>
                    </div>
                </div>      
            </div>
        )
    }
    renderNewButton(params){
        if (this.hasNew){
            return(
                <th key={'new'}>
                    <button className={"table-button"} onClick={()=>{
                        console.log("new pressed");
                        if (!this.state.modal){
                            params.title="Añadir "+this.title;
                            params.type="new";
                            this.setState({
                                modal:true,
                                modalParams:params
                            });
                        }
                    }}>
                        Nuevo
                    </button>
                </th>
            )
        }
    }
    render(){
        let params={};
        let data=[];
        if (this.state && this.state.table){
            //console.log('actualizo data: ', this.state.table);
            data=this.state.table;
            //console.log('valor de data ',data);
        }
        return(
            <div>
                <div>
                    <h2>{this.title}</h2>
                </div>
                <div>
                    <table>
                        <thead>
                            <tr>
                                {this.tableHeader.map((key,index)=>{
                                    return(
                                    <th key={index}>{key}</th>
                                    )
                                })}
                                {this.renderNewButton(params)}
                                
                            </tr>
                        </thead>
                        
                        <tbody>
                            {data.map((item,index)=>{
                                return (
                                    <tr key={index} >
                                        {Object.keys(item).map((key,index)=>{
                                                if((this.edit)){
                                                    return(
                                                        <td key={index} 
                                                            onClick={()=>{
                                                                console.log('edit Pressed');
                                                                if (!this.state.modal){
                                                                    params.title="Usuario: "+item.user;
                                                                    params.type="edit";
                                                                    params.item=item;
                                                                    this.setState({
                                                                        modal:true,
                                                                        modalParams:params});
                                                                }
                                                                }}>
                                                                    {item[key]}
                                                        </td>
                                                        
                                                    )  
                                                }else{
                                                    return(
                                                        <td key={index}>
                                                            {item[key]}
                                                        </td>
                                                        
                                                    )
                                                }
                                                
                                            })
                                        } 
                                        <td key={'del'+index} style={{"textAlign":"center"}}>
                                            <button className={"table-button"}
                                                onClick={()=>{
                                                console.log('del Pressed');
                                                if (!this.state.modal){
                                                    params.title=this.title+ " delete";
                                                    params.type="del";
                                                    params.item=item;
                                                    this.setState({
                                                        modal:true,
                                                        modalParams:params
                                                    });
                                                }
                                            }}>
                                                Eliminar
                                            </button> 
                                        </td> 
                                    </tr>
                                )
                            })}
                        </tbody>
                        <tfoot></tfoot>
                    </table>
                </div>
                {this.renderModal()}
            </div>
        )
        
    }
}